import * as Immutable from 'immutable'
import moment from 'moment-timezone'
import {headerWithCredentials, ruleServerUrl} from 'configs/rule-server'
import walkInInterestsService from '../../../services/walk-in-interests-service'
import campaignService from '../../../services/campaigns-service.js'
import {SELECT_VIEW} from '../../Campaign/modules/campaign'
import update from 'react-addons-update'

// ------------------------------------
// Constants
// ------------------------------------
export const SET_WALK_IN_INTERESTS_FILTER = 'SET_WALK_IN_INTERESTS_FILTER'
export const LOAD_WALK_IN_INTERESTS = 'LOAD_WALK_IN_INTERESTS'
export const LOAD_WALK_IN_INTEREST_FORM = 'LOAD_WALK_IN_INTEREST_FORM'
export const LOAD_STORE_OPTIONS = 'LOAD_STORE_OPTIONS'
export const SELECTED_COLUMN_VALUES = 'SELECTED_COLUMN_VALUES'

// ------------------------------------
// Actions
// ------------------------------------

// ------------------------------------
// Action Handlers
// ------------------------------------

export function setWalkInInterestsFilter (filter) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_WALK_IN_INTERESTS_FILTER,
      filter: filter
    })
  }
}

export function loadWalkInInterests (filter) {
  return (dispatch, getState) => {
    return walkInInterestsService.getWalkInInterests(filter)
      .then(function (walkInInterests) {
        dispatch({
          type: LOAD_WALK_IN_INTERESTS,
          walkInInterests: Immutable.fromJS(walkInInterests)
        })
      })
  }
}

export function loadWalkInInterestForm () {
  return (dispatch, getState) => {
    return walkInInterestsService.getWalkInInterestForm()
      .then(function (walkInInterestForm) {
        dispatch({
          type: LOAD_WALK_IN_INTEREST_FORM,
          walkInInterestForm: walkInInterestForm
        })
      })
  }
}

export function selectedwalkInInterestColValues (payload) {
  return (dispatch, getState) => {
    dispatch({
      type: SELECTED_COLUMN_VALUES,
      selectedColumns: payload
    })
  }
}

// ------------------------------------
// Reducer
// ------------------------------------

let defaultFilter = Immutable.fromJS({
  startDate: moment().subtract(2, 'days').toDate(),
  endDate: moment().toDate(),
  storeNames: []
})

export function walkInInterestsFilterReducer (state = defaultFilter, action) {
  switch (action.type) {
    case SET_WALK_IN_INTERESTS_FILTER: {
      return action.filter
    }
    default:
      return state
  }
}

let defaultWalkInInterests = Immutable.fromJS([])

export function walkInInterestsReducer (state = defaultWalkInInterests, action) {
  switch (action.type) {
    case LOAD_WALK_IN_INTERESTS: {
      return action.walkInInterests
    }
    default:
      return state
  }
}

let defaultWalkInInterestForm = {}

export function walkInInterestFormReducer (state = defaultWalkInInterestForm, action) {
  switch (action.type) {
    case LOAD_WALK_IN_INTEREST_FORM: {
      return action.walkInInterestForm
    }
    default:
      return state
  }
}

export function selectedValuesReducer (state = [], action) {
  switch (action.type) {
    case SELECTED_COLUMN_VALUES: {
      return action.selectedColumns
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/WalkInInterests/modules/walkInInterests.js